export const RESET_SUBUSER_PASSWORD_OPEN_MODAL = "RESET_SUBUSER_PASSWORD_OPEN_MODAL";
export const RESET_SUBUSER_PASSWORD_CLOSE_MODAL = "RESET_SUBUSER_PASSWORD_CLOSE_MODAL";

export const RESET_SUBUSER_PASSWORD_REQUEST = "RESET_SUBUSER_PASSWORD_REQUEST";
export const RESET_SUBUSER_PASSWORD_RESULT = "RESET_SUBUSER_PASSWORD_RESULT";